import * as THREE from 'three';
import {
  CARD1Web, MouseAction
} from '../CoordUtils.js';
import {
  Canvas2D,
  getVectorContainers
} from '@/js/util.js'
import {RoadModel} from "../models/RoadModel"; 
import  {RoadStake} from "../models/RoadStake";
import  {RoadUnit} from "../models/RoadUnit";
import { Navigator } from '@/drawings3D/navigation'
import { MedialDivider } from '@/drawings3D/models/MedialDivider'
import { MedialDividerDrawer } from '@/drawings3D/modelDrawing/MedialDividerDrawer'

import { GuardRail } from '@/drawings3D/models/GuardRail'
import { Tunnel } from '@/drawings3D/models/Tunnel'
import { BaseDrawer } from '@/drawings3D/modelDrawing/BaseDrawer'
import { GuardRailDrawer } from '@/drawings3D/modelDrawing/GuardRailDrawer'
import { TunnelDrawer } from '@/drawings3D/modelDrawing/TunnelDrawer'
import { LaneDividerLinesDrawer } from '@/drawings3D/modelDrawing/LaneDividerLinesDrawer'
import {EarthDrawer} from './EarthDrawer'
export class RoadDrawer extends BaseDrawer{
  constructor(roadStakeRange, sceneManager, roadManager, firstInit, roadPartOption) {
    super(sceneManager);
    this.name = roadStakeRange.roadModel.roadName;
    this.sceneManager = sceneManager;

    this.modelData = roadStakeRange.modelData;
    this.roadModel= roadStakeRange.roadModel;
    //材质和纹理的定义
    this.slopeMaterial = new THREE.MeshPhongMaterial({
      map: new THREE.TextureLoader().load("/static/bimroad/textures/slope.jpg")
    });

    this.roadFaceMaterial = new THREE.MeshLambertMaterial({
      map: new THREE.TextureLoader().load("/static/bimroad/textures/roadsurface.png")
    });
    // this.whiteSignMaterial = new THREE.MeshLambertMaterial({
    //   color: 0xffffff
    // });
    this.roadManager = roadManager;
    this.roadId = roadStakeRange.roadModel.roadId;
    this.roadStakeRange = roadStakeRange;
    this.firstInit = firstInit;
    var roadComponentMaterialArray = [];
    this.faceMaterial = roadComponentMaterialArray;
    if (this.roadManager.roadMaterials){
      this.assignMaterailsIndex(this.roadManager.roadMaterials);
    }

    roadComponentMaterialArray.push(this.roadFaceMaterial);
    roadComponentMaterialArray.push(this.slopeMaterial);
    this.roadPartOption = roadPartOption;
  }
 
  assignMaterailsIndex(materails){
    var that = this;
    materails.map(item=>{
        that.faceMaterial.push(new THREE.MeshLambertMaterial({
          map: new THREE.TextureLoader().load(item)
      }));
    });

  }

  // renderRoadUnit(params) {
  //   var road = params.road;
  //   //这里的this是scope所定义
  //   if (params.prevstakeVal == undefined) {
  //     params.prevstakeVal = 0;
  //   }

  //   let firstInit = false;
  //   if (params.startStake == null) {
  //     firstInit = true;
  //     var start = params.data[0];
  //     var end = params.data[1];
  //     end.center = new Object();
  //     end.center.z = end.gisData.longtitude - this.sceneManager.CoordOffset.lon;
  //     end.center.x = end.gisData.latitude - this.sceneManager.CoordOffset.lat;
  //     end.center.y = (end.leftRootHeight + end.rightRootHeight) / 2;
  //     params.startStake = new RoadStake(start, this.sceneManager.CoordOffset, end);
  //     //this.sceneManager.camera.move(new THREE.Vector3(params.startstake.center.x, params.startstake.center.y + 20, params.startstake.center.z - 30), new THREE.Vector3(params.startstake.center.x, params.startstake.center.y + 10, params.startstake.center.z));
  //     params.endStake = new RoadStake(end, this.sceneManager.CoordOffset, params.startStake);
  //     road.model.roadStake.push(params.startStake);
  //   }

  //   road.onJobDone = params.onJobDone;
  //   road.model.roadStake.push(params.endStake);
  //   var roadUnit = new RoadUnit(params.startStake, params.endStake);
  //   roadUnit.prevStakeVal = params.prevStakeVal;
  //   roadUnit.nextStakeVal = params.endStake.stakeval;
  //   road.model.roadunits.push(roadUnit);
  //   roadUnit.road = road;
   
  //   road.CoordOffset = this.sceneManager.CoordOffset;
  //   road.model.roadunitMap[roadUnit.start.stakeval] = roadUnit;
  //   params.prevStakeVal = params.startStake.stakeval;
  //   let cursor = params.index + 1;
  //   let dataObj = {
  //     startStake: params.endStake,
  //     data: params.data,
  //     road: road,
  //     drawer: params.drawer,
  //     index: cursor,
  //     prevStakeVal: params.prevStakeVal,
  //     onJobDone: road.onJobDone
  //   };
  //   if (params.data.length <= cursor + 1) {
  //     dataObj.done = true
  //   } else {
  //     dataObj.endStake = new RoadStake(params.data[cursor + 1], road.CoordOffset, dataObj.startStake);
  //   }

  //   return dataObj;
  // }


  drawRoadStakePts(roadStake){
    var geometry1 = new THREE.SphereGeometry( 1, 10, 10 );
    var geometry2 = new THREE.SphereGeometry( 1, 10, 10 );
    var geometry3 = new THREE.SphereGeometry( 1, 10, 10 );
    var material1 = new THREE.MeshBasicMaterial( {color: 0xff0000} );
    var material2 = new THREE.MeshBasicMaterial( {color: 0x0000ff} );
    var material3 = new THREE.MeshBasicMaterial( {color: 0x00ffff} );
    var sphere1 = new THREE.Mesh( geometry1, material1 );
    var sphere2 = new THREE.Mesh( geometry2, material2 );
    var sphere3 = new THREE.Mesh( geometry3, material3 );
    this.sceneManager.scene.add( sphere1 );
    this.sceneManager.scene.add( sphere2 );
    this.sceneManager.scene.add( sphere3 );
    sphere1.position.copy(roadStake.a1);
    sphere2.position.copy(roadStake.a2);
    sphere3.position.copy(roadStake.a3);
  }

  buildRoadstakeDrawingPoints(stepFactor) {
    let stakeCurvePtsA1 = [];
    let stakeCurvePtsA2 = [];
    let stakeCurvePtsB1 = [];
    let stakeCurvePtsB2 = [];
    var _this = this;
    
    for (let i = this.roadStakeRange.start; i <= this.roadStakeRange.end; i++){
      var item = this.modelData[i];
      var curveItemA1 = new THREE.Vector3(item.a1.x, item.a1.y, item.a1.z);
      var curveItemA2 = new THREE.Vector3(item.a2.x, item.a2.y, item.a2.z);
      var curveItemB1 = new THREE.Vector3(item.b1.x, item.b1.y, item.b1.z);
      var curveItemB2 = new THREE.Vector3(item.b2.x, item.b2.y, item.b2.z);
      curveItemA1.stake = curveItemA2.stake = curveItemB1.stake = curveItemB2.stake = item;
      var roadUnit = _this.roadModel.getRoadUnitByStakeVal(item.stakeval);
      curveItemA1.roadUnit = curveItemA2.roadUnit = curveItemB1.roadUnit = curveItemB2.roadUnit = roadUnit;
      stakeCurvePtsA1.push(curveItemA1);
      stakeCurvePtsA2.push(curveItemA2);
      stakeCurvePtsB1.push(curveItemB1);
      stakeCurvePtsB2.push(curveItemB2);
    }
    
    var curveA1 = new THREE.CatmullRomCurve3(stakeCurvePtsA1);
    var curveA2 = new THREE.CatmullRomCurve3(stakeCurvePtsA2);
    var curveB1 = new THREE.CatmullRomCurve3(stakeCurvePtsB1);
    var curveB2 = new THREE.CatmullRomCurve3(stakeCurvePtsB2);
    this.stakeDrawingPoints = new Object();
    this.stakeDrawingPoints.a1 = getVectorContainers(curveA1.getPoints(this.roadModel.model.roadStake.length * stepFactor), stakeCurvePtsA1);
    this.stakeDrawingPoints.a2 = getVectorContainers(curveA2.getPoints(this.roadModel.model.roadStake.length * stepFactor), stakeCurvePtsA2);
    this.stakeDrawingPoints.b1 = getVectorContainers(curveB1.getPoints(this.roadModel.model.roadStake.length * stepFactor), stakeCurvePtsB1);
    this.stakeDrawingPoints.b2 = getVectorContainers(curveB2.getPoints(this.roadModel.model.roadStake.length * stepFactor), stakeCurvePtsB2);

  }

  drawRoadSurfaceFace() {
    var vertices = [];
    //从起点往终点望去，a1为右，a2为左
    var pointLength = this.stakeDrawingPoints.a1.length;
    this.stakeDrawingPoints.a1.map(item => {
      vertices.push(item);
    });
    this.stakeDrawingPoints.a2.map(item => {
      vertices.push(item);
    });
    this.stakeDrawingPoints.b1.map(item => {
      vertices.push(item);
    });
    this.stakeDrawingPoints.b2.map(item => {
      vertices.push(item);
    });

    //对于匝道，需要添加一个匝道和主干道的贴合点
    if (this.roadModel.preStake){
      vertices.push(this.roadModel.preStake.auxPt);
    }
    //按照index来确定三角面
    var faces = [];
    var roadSurfaceIndex = this.faceMaterial.length - 2;
    var roadSlopeIndex = this.faceMaterial.length - 1;
    for (var i = 0; i < pointLength - 1; i++) {
      if (this.stakeDrawingPoints.a1[i].stake.stage != undefined){
        roadSurfaceIndex = this.stakeDrawingPoints.a1[i].stake.stage;
      }
      //顺时针方向对着摄像机，渲染可见
      //1是material的index 
      faces.push(new THREE.Face3(i + 1, i, pointLength + i, null, null, roadSurfaceIndex));
      faces.push(new THREE.Face3(pointLength + i, pointLength + i + 1, i + 1, null, null, roadSurfaceIndex));
      // //左边坡面
      // faces.push(new THREE.Face3(pointLength + i + 1, pointLength + i, 3 * pointLength + i, null, null, roadSlopeIndex));
      // faces.push(new THREE.Face3(3 * pointLength + i, 3 * pointLength + i + 1, pointLength + i + 1, null, null, roadSlopeIndex));
      // //右边坡面
      // faces.push(new THREE.Face3(i, i + 1, 2 * pointLength + i + 1, null, null, roadSlopeIndex));
      // faces.push(new THREE.Face3(2 * pointLength + i + 1, 2 * pointLength + i, i, null, null, roadSlopeIndex));
    }

     if (this.roadModel.preStake){
        faces.push(new THREE.Face3(pointLength, 0, vertices.length - 1, null, null, roadSurfaceIndex));
     }
    
    var geom = new THREE.Geometry();
    geom.vertices = vertices;
    geom.faces = faces;
    geom.faceVertexUvs[0] = [];
    //计算贴图
    var curMaterialIndex = null;
    var curUvPos = 0;
    var counter = 0;
    var helper = new CARD1Web.CoordUtils.Helper();
    for (var i = 0; i < pointLength - 2; i++) {
      if (this.stakeDrawingPoints.a1[i].stake.stage != undefined){
        roadSurfaceIndex = this.stakeDrawingPoints.a1[i].stake.stage;
      }
      //如果当前材质发生变化则重置uv的位置到0.0
      if (curMaterialIndex != roadSurfaceIndex){
        curMaterialIndex = roadSurfaceIndex;
        curUvPos = 0;
      }
      var deltaX = helper.getUvDeltaByRect(1, this.stakeDrawingPoints.a1[i], this.stakeDrawingPoints.a2[i],
                                  this.stakeDrawingPoints.a1[i + 1], this.stakeDrawingPoints.a2[i + 1]);
      //超过了纵向的最大值1.0则重置从0.0开始记
      if (curUvPos + deltaX >= 1.0){
        //剩余的未裁剪部分和所需的部分比例相差不大，可以使用
        if((1 - curUvPos) / deltaX > 0.8){
          deltaX = 1-curUvPos;
        }
        else{
          curUvPos = 0;
        }
      }

      geom.faceVertexUvs[0][counter] = [new THREE.Vector2(curUvPos + deltaX, 0), new THREE.Vector2(curUvPos, 0), new THREE.Vector2(curUvPos, 1)];
      counter++;
      geom.faceVertexUvs[0][counter] = [new THREE.Vector2(curUvPos, 1), new THREE.Vector2(curUvPos + deltaX, 1), new THREE.Vector2(curUvPos + deltaX, 0)];
      counter++;
      curUvPos += deltaX;

      if (curUvPos >=1.0){
        curUvPos = 0;
      }
    }

    
    // var surface = [new THREE.Vector2(0, 0), new THREE.Vector2(1, 0), new THREE.Vector2(0, 1), new THREE.Vector2(1, 1)];
    // for (let i = 0; i < faces.length - ((this.roadModel.preStake) ? 2 : 1); i++) {
    //   if (i % 2 == 0) {
    //     geom.faceVertexUvs[0][i] = [surface[0], surface[1], surface[3]];
    //   } else {
    //     geom.faceVertexUvs[0][i] = [surface[3], surface[2], surface[0]];
    //   }
    // }

    // if (this.roadModel.preStake){
    //   geom.faceVertexUvs[0][faces.length - 1] = [surface[0], surface[1], surface[3]];
    // }
    geom.computeFaceNormals();
    var roadmesh = new THREE.Mesh(geom, this.faceMaterial);
    this.geometry = geom;
    this.geometry.ownerDrawer = this;
    this.mesh.add(roadmesh);
    return this.mesh;
  }


  getDrawingStartStake(stake){
    if (this.modelData[this.roadStakeRange.start].stakeval > stake){
      return this.modelData[this.roadStakeRange.start].stakeval;
    }
    return stake;
  }

  getDrawingEndStake(stake){
    if (this.modelData[this.roadStakeRange.end].stakeval < stake){
      return this.modelData[this.roadStakeRange.end].stakeval;
    }
    return stake;
  }

  drawRoadSigns(road, stepFactor) {
    if (this.roadPartOption == undefined || this.roadPartOption.disabled) return;
    var roadSigns = new Object();
    var that = this;
    if(road.mediaDividers && this.roadPartOption.mediaDividers){
      var mediaDividers = [];
      road.mediaDividers.map(item=>{
        var startStake = that.getDrawingStartStake(item.startStake);
        var endStake = that.getDrawingEndStake(item.endStake);
        var medialDivider = new MedialDivider(item.width, item.height, startStake, endStake, that.modelData);
        var medialDividerDrawer = new MedialDividerDrawer(medialDivider, that.sceneManager, stepFactor);
        mediaDividers.push(medialDividerDrawer.draw());
      });
      roadSigns.mediaDividers = mediaDividers;
    }
    
    if (road.guardRails && this.roadPartOption.guardRails){
      var guardRails = [];
      road.guardRails.map(item=>{
        var startStake = that.getDrawingStartStake(item.startStake);
        var endStake = that.getDrawingEndStake(item.endStake);
        var height = item.height;

        //TODO:暂时不考虑右道
        if (that.roadSections){
          var secStartStake = startStake;
          for (var i = 0; i < that.roadSections.length; i++){
              if (that.roadSections[i].stakeval < startStake) continue;
              if (that.roadSections[i].stakeval > endStake) break;
              var secEndStake = that.roadSections[i].stakeval;
              var guardRail = new GuardRail(height, secStartStake, secEndStake, that.modelData);
              var guardRailDrawer = new GuardRailDrawer(guardRail, that.sceneManager, true, stepFactor);
              guardRails.push(guardRailDrawer.draw());
              
              secStartStake = secEndStake + that.roadSections[i].width;
              
          } 

          var guardRail = new GuardRail(height, secStartStake, endStake, that.modelData);
          var guardRailDrawer = new GuardRailDrawer(guardRail, that.sceneManager, true, stepFactor);
          guardRails.push(guardRailDrawer.draw()); 
      
        }
        else{
              var guardRail = new GuardRail(height, startStake, endStake, that.modelData);
              var guardRailDrawer = new GuardRailDrawer(guardRail, that.sceneManager, true, stepFactor);
              guardRails.push(guardRailDrawer.draw());  
        }

        
       
        var guardRailR = new GuardRail(height, startStake, endStake, that.modelData);
        var guardRailDrawerR = new GuardRailDrawer(guardRailR, that.sceneManager, false, stepFactor);
        guardRails.push(guardRailDrawerR.draw());
      })

      roadSigns.guardRails = guardRails;
    }  
    

    var startStake = this.modelData[this.roadStakeRange.start].stakeval;
    var endStake = this.modelData[this.roadStakeRange.end].stakeval;
    
    if (this.roadPartOption.laneDividers){
      var laneDividerLinesDrawer = new LaneDividerLinesDrawer(road.laneNo, startStake, endStake, that.modelData, this.sceneManager, 1, stepFactor);
      roadSigns.laneDividers = laneDividerLinesDrawer.draw();  
    }
    
    return roadSigns;
  }

  //隧道区域
  drawTunnels(road){
    var tunnelArray = new Array();
    var tunnelSign = false;
    var tunnelInnerHeight = 6;
    var tunnelOuterWidth = 4;
    var tunnelOuterHeight = 10;
    var tunnelStakeArray;
    road.model.roadStake.map(item=>{
      if (item.nearByFacility == 1){
        if (!tunnelSign){
          tunnelStakeArray = new Array();
          tunnelSign = true;
        }
        tunnelStakeArray.push(item);
      }
      else if (tunnelSign){
        //根据之前的roadstakes组成一个隧道
        var tunnel = new Tunnel(tunnelInnerHeight, tunnelOuterWidth, tunnelOuterHeight, tunnelStakeArray, road.model.roadStake);
        tunnelArray.push(tunnel);
        tunnelSign = false;
      }
    });
    //最后一段也是tunnel
    if (tunnelSign){
        var tunnel = new Tunnel(tunnelInnerHeight, tunnelOuterWidth, tunnelOuterHeight, tunnelStakeArray);
        tunnelArray.push(tunnel);
    }
    tunnelArray.map(item=>{
      var tunnelDrawer = new TunnelDrawer(item, this.sceneManager);
      tunnelDrawer.draw();
    });
  }

  //根据传入的匝道起始位置计算其基缘和坡脚坐标
  getRampCoord(stakeval, isYK){
    var road = this.roadModel;
    var index = stakeval / road.stakeInterval;    
    var roadStakes = road.model.roadStake;
    var start = roadStakes[index];
     var end = roadStakes[index + 1];
     var b = new THREE.Vector3();
     var alpha = (stakeval - start.stakeval) / road.stakeInterval;
     b.lerpVectors(start.b2, end.b2, alpha);
     var a = new THREE.Vector3();
     a.lerpVectors(start.a2, end.a2, alpha);
     return {'a': a, 'b': b};
  }

  getStakeCoord(stakeval, index, stakeInterval, roadStakes, isYK){
     var start = roadStakes[index];
     var end = roadStakes[index + 1];
     var b = new THREE.Vector3();
     var alpha = (stakeval - start.stakeval) / stakeInterval;
     b.lerpVectors(start.b2, end.b2, alpha);
     var a = new THREE.Vector3();
     a.lerpVectors(start.a2, end.a2, alpha);
     return {'a': a, 'b': b};
  }


  drawRamp(road){
    var _this = this;
    if (road.rampData){
      _this.roadSections = new Array();    
      road.rampData.map(item=>{
          var web3DVue = _this.sceneManager.webView;
          _this.roadSections.push({"stakeval" : item.startRoadStake, "width": item.width});
          web3DVue.axios.get('http://localhost:8181/getroaddata?startStake=0&endStake=10000&roadId=' + item.id).then(function(response) {
              //TODO:判断道路的当前所在路段匝道，服务区互通等信息
              
              var data = response.data;
              //将交汇点设置在主道上插入到匝道的点集中
              var rampStart = _this.getRampCoord(item.startRoadStake);
              var rampEnd = _this.getRampCoord(item.startRoadStake + item.width);
              var startRoadStake = new RoadStake(null, _this.sceneManager.CoordOffset);
              startRoadStake.b2 = rampStart.b;
              startRoadStake.b1 = rampEnd.b;
              startRoadStake.a2 = rampStart.a;                
              startRoadStake.a1 = rampEnd.a;
              startRoadStake.a3 = new THREE.Vector3();
              startRoadStake.a3.lerpVectors(startRoadStake.a1, startRoadStake.a2, 0.5);
              startRoadStake.center = new THREE.Vector3();
              startRoadStake.center.lerpVectors(startRoadStake.b1, startRoadStake.b2, 0.5);  
              startRoadStake.stakeval = 0;
              startRoadStake.calcBasePt();
              var auxPtA3 = new THREE.Vector3();
              var auxPtA2 = new THREE.Vector3();
              
              var startCalcRoadStake = _this.roadModel.model.roadStake[item.startRoadStake/_this.roadModel.stakeInterval];
              var endCalcRoadStake = _this.roadModel.model.roadStake[(item.startRoadStake + item.width)/_this.roadModel.stakeInterval];
              auxPtA3.lerpVectors(startCalcRoadStake.a3, endCalcRoadStake.a3, 0.5);
              auxPtA2.lerpVectors(startCalcRoadStake.a2, endCalcRoadStake.a2, 0.5);
              startRoadStake.auxPt = new THREE.Vector3();
              startRoadStake.auxPt.lerpVectors(auxPtA3, auxPtA2, 0.8);
              var zadao = new RoadDrawer(item.name, _this.sceneManager, data, 1);
              zadao.render(web3DVue);
              zadao.roadModel.preStake = startRoadStake;
              
        });

      })


    }
  }

  render(web3DView) {
    var _this = this;
    var stepFactor = (this.roadModel.model.roadStake[1].stakeval - this.roadModel.model.roadStake[0].stakeval) / 5; //计算需要插值的因子
    if (stepFactor == 0) stepFactor = 1;
    this.buildRoadstakeDrawingPoints(stepFactor);
    var renderedMesh = new Object();
    renderedMesh.roadSurface = this.drawRoadSurfaceFace();
    

        //增加交通标识
    //匝道绘制，暂时不考虑
    //web3DView.drawer.drawRamp(road);
    renderedMesh.roadSigns = this.drawRoadSigns(this.roadModel, stepFactor);
    //this.drawTunnels(this.roadModel);
    
    this.sceneManager.roadNav.onstakeChanged = function(stake) {
      _this.moveToVerticalTransectCenter(stake);
      _this.$refs.webMap.addMarker(stake);
    }


    //主干道渲染时移动摄像机
    if (this.roadModel.roadType == 0 && this.firstInit){
      this.sceneManager.camera.moveToRoadUnit(this.roadModel.model.roadunits[0]);  
    }
    
    //每一次更新道路需要更新相机当前位置，以在相机移动后判断是否需要再次更新道路
    this.sceneManager.camera.setLastUpdateRoadPos();
    //debug每个桩的位置
    // var counter = 0;
    //  web3DView.drawer.roadModel.model.roadStake.map(item=>{
    //    if (counter < 1){
    //    web3DView.drawer.drawRoadStakePts(item); 
    //    }
    //    counter++;
    // });
    this.roadManager.addRenderedMesh(this.roadId, this.roadModel, this.roadStakeRange, renderedMesh);
    this.sceneManager.geometryManager.addRoad(this, true);
  }

 
  //移动当前选中的点到纵断面中心
  moveToVerticalTransectCenter(stake) {
    var jqueryDom = $('#verticalTransect');
    var canvas = new Canvas2D(jqueryDom.width(), jqueryDom.height());

    var startPoint = { x: canvas.width / 2, y: stake.center.y }; //画布中线上画圆点
    canvas.drawCircle(startPoint, { radius: 5, color: '#ff0000' });
    var lstartPoint = { x: canvas.width / 2, y: stake.center.y };
    var rStartstake = stake;
    var xRpos = startPoint.x;

    while (xRpos < canvas.width + 50) {
      //向右画
      xRpos += 10; //10控制点间距离

      if (rStartstake.asStartRoadUnit == null || rStartstake.asStartRoadUnit.end == null) {
        break;
      }
      var rightstake = rStartstake.asStartRoadUnit.end;
      var endPoint = { x: xRpos, y: rightstake.center.y };
      canvas.drawLine(startPoint, endPoint, { color: '#000000' });
      startPoint = endPoint;
      rStartstake = rightstake;
    }

    var lStartstake = stake;
    //向左画
    var xLpos = lstartPoint.x;

    while (xLpos > -50) {
      xLpos -= 10; //10控制点间距离

      if (lStartstake.asEndRoadUnit == null || lStartstake.asEndRoadUnit.start == null) {
        break;
      }
      var leftstake = lStartstake.asEndRoadUnit.start;
      var endPoint = { x: xLpos, y: leftstake.center.y };
      canvas.drawLine(lstartPoint, endPoint, { color: '#000000' });
      lstartPoint = endPoint;
      lStartstake = leftstake;
    }

    jqueryDom.empty();
    jqueryDom.append(canvas.get());

  }

  doSelect(intersect, action, web3DVue){
    var faceIndex = intersect.face.a;
    var roadUnit = this.geometry.vertices[faceIndex].roadUnit;
    //以最左边为参考点
    var pt1 = roadUnit.start.a1;
    var pt2 = roadUnit.end.a1;
    var pt3 = roadUnit.end.a2;
    var footPoint = this.getFootPoint(intersect.point, pt1, pt2);
    var footPointDist = footPoint.distanceTo(pt1);
    
    //this.drawVirtualLine(intersect.point, footPoint, 0xff0000);
    if (action.mouse == MouseAction.CLICK){
      if (web3DVue.map){
        web3DVue.map.addMarker(roadUnit.start);  
      }
      

      if (action.model != undefined){
        this.sceneManager.fixModelAtPos(intersect.point);
      }
    }
    else if (action.mouse == MouseAction.MOUSEMOVE){
      web3DVue.curCoordDesc =roadUnit.start.stakeval + web3DVue.sceneManager.actualStakeVal;
      if (action.model != undefined){
        action.model.position.copy(intersect.point);
        action.model.position.y += 0.05;
      
        if(action.model.loader){
          var distance = intersect.point.distanceTo(footPoint);
          var roadWidth = pt2.distanceTo(pt3);
          var lookAtPt = new THREE.Vector3();
          lookAtPt.lerpVectors(pt2, pt3, distance / roadWidth);
          action.model.loader.setStake(roadUnit.start, roadUnit.end, lookAtPt); //部分控件需要根据当前桩号设置方向
        }
      }
    }
    
  }

//求点到直线的垂足坐标，公式请参见https://www.cnblogs.com/mazhenyu/p/3508735.html
  getFootPoint(pt0, pt1, pt2){
    var k = -((pt1.x - pt0.x) * (pt2.x - pt1.x) + (pt1.y - pt0.y) * (pt2.y - pt1.y) 
    + (pt1.z - pt0.z) * (pt2.z - pt1.z)) / (Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2) + Math.pow(pt2.z - pt1.z, 2));
    
    var pt = new THREE.Vector3(k * (pt2.x - pt1.x) + pt1.x, k * (pt2.y - pt1.y) + pt1.y, k * (pt2.z - pt1.z) + pt1.z); 
    return pt;
  }

  drawVirtualLine(first, second, color){
    var line = new THREE.Geometry();
    line.vertices.push(new THREE.Vector3(first.x, first.y, first.z));
    line.vertices.push(new THREE.Vector3(second.x, second.y, second.z));
    var colors = [];
    colors[0] = new THREE.Color(color);
    colors[1] = new THREE.Color(color);
    line.colors = colors;

    var material = new THREE.LineDashedMaterial({
      vertexColors: true,
      color: color,
      dashSize: 2,
      gapSize: 2,
      scale: 0.1
    });

    this.sceneManager.scene.add(new THREE.Line(line, material));
  }
}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/RoadDrawer.js